import { Component, Inject, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ModalController, ToastController } from "@ionic/angular";
import { UploadFileModalComponent } from "../../upload-file-modal/upload-file-modal.component";
@Component({
  selector: "app-caste-val-view-profile-document",
  templateUrl: "./caste-val-view-profile-document.component.html",
  styleUrls: ["./caste-val-view-profile-document.component.scss"],
})
export class CasteValidityViewProfileDocumentComponent implements OnInit {
  activeLang: string = "en";
  fileType: string;
  form: FormGroup = new FormGroup({});
  selectedFile: File;
  base64: string | ArrayBuffer;
  constructor(
    private modalCtrl: ModalController,
    private toastController: ToastController

  ) {}
  ngOnInit() {

    this.form = new FormGroup({
      file: new FormControl(null, Validators.required),
    });

  }

  onFileSelect(event) {
    this.selectedFile = event.target.files[0];
  }


  onSubmit() {
    if (this.form.valid) {
      const reader = new FileReader();
      console.log(this.selectedFile);
      reader.readAsDataURL(this.selectedFile);
      reader.onload = () => {
        this.base64 = reader.result;
      };

      console.log("this.base64 = > ",this.base64);

    }
    else {
      this.showErrorToast("Please upload file");
    }
  }

  async uploadSignedAgrmntLtr() {
    this.fileType = "FILE";
    const modal = await this.modalCtrl.create({
        component: UploadFileModalComponent,
        componentProps: {
            modalHeader: "Upload File",
            // base64: this.data.agreementLtrFile != null? this.data.agreementLtrFile:null,
            fileType: "File",
        }
    });
    modal.present();
  
    const { data } = await modal.onWillDismiss();
    
    if (data != null) {
        // this.onSubmit(data, this.fileType);
        console.log(data);
    }
  }

  async showErrorToast(errorMessage: string) {
    const toast = await this.toastController.create({
      message: errorMessage,
      icon: "information-circle",
      position: "top",
      duration: 2000,
    });
    toast.present();
  }

}
